export default __webpack_public_path__ + "static/media/searchIcon.75816660.svg";